<mat-toolbar>
  <div class="container">
    <span class="customer-header-logo" (click)="GoToDashboard()"> S9 </span>
    <div class="right-side-menu">
      <span>
        <img src="assets/img/location.svg" />
        Track
      </span>
      <span><img src="assets/img/bell.svg" /></span>
      <div class="dropdown" matTooltip="Profile" *ngIf="token">
        <a mat-button [matMenuTriggerFor]="menu"
          ><img
            class="header-profile"
            src="{{ profilePic ? profilePic : 'assets/img/profilesimg.svg' }}"
          />Hi,
          <span style="text-transform: capitalize">{{ userName }}</span>
        </a>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="GoToProfile()">Profile</button>
          <div class="seperator"></div>
          <button mat-menu-item (click)="trips()">Trips</button>
          <div class="seperator"></div>
          <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
      </div>
      <div *ngIf="!token">
        <button mat-flat-button class="header-login-btn" (click)="login()">Login / Sign In</button>
      </div>
    </div>
  </div>
</mat-toolbar>
